<template>
    <div class="container">
        <h4 class="title is-4">Debug Topics</h4>
        <nav class="level" v-if="topicFamilies.length > 0">
            <router-link v-for="(topicFamily, index) in topicFamilies" :key="index" :to="{path: '/debug/topic/' + index}">{{topicFamily}}</router-link>
        </nav>
        <div v-else>No topic families.</div>
        <div class="container has-text-left margin_top_1rem">
            <b-field label="Query topic value:">
                <b-input placeholder="Enter topic... ex: live/objects/23/state/value" v-model="topicName"></b-input>
            </b-field>
            <b-field label="Value:">{{topicValue}}</b-field>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import BField from "buefy/src/components/field/Field";
    import BInput from "buefy/src/components/input/Input";

  export default {
    components: {
      BInput,
      BField},
    name: "screendebugtopics",
    data() {
      return {
        topicName: ''
      };
    },
    computed: {
      ...mapGetters('mqtt', ['topicFamilies', 'mapping']),
      topicValue() {
        if (typeof this.mapping[this.topicName] !== 'undefined') {
          return this.mapping[this.topicName];
        }

        return '-';
      }
    }
  }
</script>

<style scoped>
.margin_top_1rem {
    margin-top: 1rem;
}
</style>